import * as React from 'react';
import './multiSelector.scss';
import { cn } from '../../utils';
import { removeDuplicates } from 'rcd-cpp-workspace/utils/array';

type Props<Id = string> = {
  options: MultiSelector.Option<Id>[];
  selected: Id[];
  dual?: boolean;
  onChange: (ids: Id[]) => void;
  headers?: string[];
};

export namespace MultiSelector {
  export type Option<Id = string> = {
    name: string;
    id: Id;
  };
}

export const MultiSelector = <Id,>({
  headers = [],
  options,
  selected,
  dual,
  onChange
}: Props<Id>) => {
  const [selected01, setSelected01] = React.useState<Id[]>(
    dual ? [] : selected
  );
  const [selected02, setSelected02] = React.useState<Id[]>([]);
  const onChangeO1 = (vals: Id[]) => {
    setSelected01(vals);
    if (!dual && onChange) onChange(vals);
  };
  const options01 = !dual
    ? options
    : options.filter(o => !selected?.includes(o.id));

  return (
    <div
      className={cn('cp-multi-selector-container', {
        ['cp-multi-selector-dual']: dual
      })}
    >
      <Selector
        options={options01}
        selected={selected01}
        onChange={onChangeO1}
        header={headers[0]}
      />
      {dual && (
        <>
          <div className="cp-multi-selector-mover">
            <div>
              <div
                onClick={() => {
                  if (selected01.length) {
                    onChange(removeDuplicates([...selected, ...selected01]));
                    setSelected01([]);
                  }
                }}
                className={cn({ disabled: !selected01.length })}
              >
                {/* <Arrow direction="right" /> */}
              </div>
              <div
                onClick={() => {
                  if (selected02.length) {
                    onChange(selected.filter(s => !selected02.includes(s)));
                    setSelected02([]);
                  }
                }}
                className={cn({ disabled: !selected02.length })}
              >
                {/* <Arrow direction="left" /> */}
              </div>
            </div>
          </div>
          <Selector
            options={options.filter(o => selected?.includes(o.id))}
            selected={selected02}
            header={headers[1]}
            onChange={(vals: Id[]) => {
              setSelected02(vals);
            }}
          />
        </>
      )}
    </div>
  );
};

let id = 0;
const Selector = ({
  options,
  selected,
  onChange,
  header
}: Pick<Props<any>, 'options' | 'selected' | 'onChange'> & {
  header: string;
}) => {
  const [selectAll, setSelectAll] = React.useState(false);
  const [text, setText] = React.useState('');
  const selectAllId = React.useMemo(() => 'multiSelectorId' + ++id, []);
  const txt = text.trim().toLowerCase();
  const updateSelected = (newSel: any[]) => {
    if (onChange) onChange(newSel);
  };
  const items = options.filter(o => {
    if (txt && !o.name.toLowerCase().includes(txt)) return false;
    return true;
  });
  React.useEffect(() => {
    if (
      selectAll &&
      (items.length == 0 ||
        items.filter(i => !selected.includes(i.id)).length != 0)
    ) {
      setSelectAll(false);
    } else if (
      !selectAll &&
      items.length > 0 &&
      items.filter(i => !selected.includes(i.id)).length == 0
    ) {
      setSelectAll(true);
    }
  }, [selected, items]);
  return (
    <div className="cp-multi-selector">
      {header && <div>{header}</div>}
      <div>
        <div>
          <input
            type="text"
            placeholder="Search List"
            className="form-control"
            value={text}
            onChange={e => {
              setText(e.target.value);
            }}
          />
        </div>
        <div className="cp-multi-selector-list-item">
          <div>
            <input
              type="checkbox"
              id={selectAllId}
              checked={selectAll}
              onChange={e => {
                const vals = items.map(o => o.id);
                if (e.target.checked) {
                  updateSelected(removeDuplicates(selected.concat(vals)));
                } else {
                  updateSelected(selected.filter(s => !vals.includes(s)));
                }
              }}
            />
          </div>
          <div>
            <label htmlFor={selectAllId}>Select All</label>
            <span>
              {selected.length} of {options.length} Selected
            </span>
          </div>
        </div>
        <div className="cp-multi-selector-list scrollable">
          {items.map(o => {
            return (
              <div key={o.id} className="cp-multi-selector-list-item">
                <div>
                  <input
                    type="checkbox"
                    id={o.id}
                    checked={selected.includes(o.id)}
                    onChange={e => {
                      const list = selected.filter(s => s != o.id);
                      if (e.target.checked) {
                        list.push(o.id);
                      }
                      updateSelected(list);
                    }}
                  />
                </div>
                <div>
                  <label htmlFor={o.id}>{o.name}</label>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
